import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';
import { getConversationFormName } from 'components/conversation/utils/conversationForm';
import { userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { composeEmailActions } from '../../../shared/composeEmail/actions/composeEmailActions';
import RecipientPill from '../../components/messages/utils/RecipientPill';
const mapStateToProps = (state, ownProps) => {
    return {
        id: ownProps.id,
        toList: ownProps.toList,
        ccList: ownProps.ccList,
        bccList: ownProps.bccList,
        attachedFiles: ownProps.attachedFiles,
        originalContentUrl: ownProps.originalContentUrl,
        from: ownProps.from,
        csid: state.conversation.metaConversation.conversation.id,
        isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        arrayPush: (csid, field, value) => dispatch(arrayPush(getConversationFormName(csid), field, value)),
        composeEmailFindUser: bindActionToPromise(dispatch, composeEmailActions.composeEmailFindUser),
        userModalAddUser: (payload) => dispatch(userModalActions.user.add(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(RecipientPill);
